
import {
	SlidesViewController
} from 'sharebase-app/components/slides/slidesDialog/slidesDialog';
import {
	AuthService
} from 'phoenix/services';
import {
    Slide,
    SlideConfig,
    IconSlide,
    IconSlideConfig,
    ImageSlide,
    RoleRestrictedSlide
} from 'sharebase-app/domain';
import * as mergeWith from 'lodash.mergewith'
import { CommonUtilsService } from 'util/util';

export class RoleRestrictedSlideFactory {
	public static $inject = [
        '$q',
        'pxAuthService',
        'gettextCatalog'
	];

	constructor(
        private $q,
        private pxAuthService:AuthService,
        private gettextCatalog:ng.gettext.gettextCatalog
	) {
	}

	public create(allowedRoles:string[]) {
		return new RoleRestrictedSlide(
            this.$q,
            this.gettextCatalog,
			this.pxAuthService,
			allowedRoles,
		);
    }
    
    public createIcon(iconSlideData:IconSlideConfig, allowedRoles:string[]) {
        return mergeWith(
            new RoleRestrictedSlide(
                this.$q,
                this.gettextCatalog,
                this.pxAuthService,
                allowedRoles
            ),
            new IconSlide(
                this.$q,
                this.gettextCatalog,
                iconSlideData
            )
        ) as RoleRestrictedSlide & IconSlide;
    }

    public createImage(slideData:SlideConfig, imageSrc:string, allowedRoles:string[]) {
        return mergeWith(
            new RoleRestrictedSlide(
                this.$q,
                this.gettextCatalog,
                this.pxAuthService,
                allowedRoles
            ),
            new ImageSlide(
                this.$q,
                this.gettextCatalog,
                imageSrc,
                slideData
            )
        ) as RoleRestrictedSlide & ImageSlide;
    }
}

let template = require('./uniformTemplatedSlides.template');
export abstract class UniformTemplatedSlidesController<T extends Slide> extends SlidesViewController<T> {
    public slides:T[] = [];
    public minSlideCount:number = 1;

    public static $inject = [
		'$mdPanel',
        '$mdMedia',
        '$timeout',
        '$interval',
        '$window',
        'utils'
	];
	
	constructor(
		$mdPanel,
		$mdMedia,
		$timeout,
        $interval,
        private $window,
        private utils:CommonUtilsService
	){
        super($mdPanel, $mdMedia, $timeout, $interval, template);
    }

    public goToLinkOrNext(slide: Slide) {
        if(slide.link) {
            this.$window.open(slide.link);
        }
        else {
            this.goForward();
        }
    }

    public show() {
        return this.utils.filterAsync(this.slides, (slide, index) => slide.validate())
            .then(filteredArray => {
                let wasShown = false;
                
                if(filteredArray.length >= this.minSlideCount) {
                    super.show();
                    wasShown = true;
                }

                return wasShown;
            });
    }
}


// WEBPACK FOOTER //
// ./src/sharebase-app/components/slides/uniformTemplatedSlides/uniformTemplatedSlides.ts